function DifficultWordModal() {
    this.init();
    this.setEventListeners();
}

DifficultWordModal.prototype.init = function() {
    this.el = document.createElement('div');
    this.el.classList.add('difficult-word-modal');
    this.el.classList.add('jsCloseModal');

    this.el.innerHTML = `
        <div class="difficult-word-modal__inner">
            <button class="difficult-word-modal__close-btn jsCloseModal" type="button">Sluiten</button>
            <span class="difficult-word-modal__title jsTitle"></span>
            <div class="office-project-modal__content default-styles jsContent"></div>
        </div>    
    `;

    document.body.appendChild(this.el);

    this.titleEl = this.el.querySelector('.jsTitle');
    this.contentEl = this.el.querySelector('.jsContent');
};

DifficultWordModal.prototype.setEventListeners = function() {
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            this.hide();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });
};

DifficultWordModal.prototype.set = function(title, content) {
    this.titleEl.innerHTML = title;
    this.contentEl.innerHTML = content;
};

DifficultWordModal.prototype.show = function() {
    this.el.classList.add('visible');
};

DifficultWordModal.prototype.hide = function() {
    this.el.classList.remove('visible');
};

(function() {
    let modal = null;
    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('jsDifficultWord')) {
            e.preventDefault();

            if (!modal) modal = new DifficultWordModal();
            modal.set(e.target.dataset.title, e.target.dataset.explanation);
            modal.show();
        }
    });
})();